export default __webpack_public_path__ + "static/hero-6617ddaef1733af791e8e0f77fd4d2e0.jpg";